/**
 * Created by Administrator on 2017/11/3.
 */
import {Component, OnInit, ViewChild} from "@angular/core";
import {API} from "../config/api-config";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {StroageService} from "../service/stroage";
import {Location} from "@angular/common";
import {NgForm} from "@angular/forms";
declare var alertify:any;
@Component({
  templateUrl:'./editAccount.html'
})

export class EditAccount implements OnInit{
  ngAfterViewInit(): void {
    //订阅表单值改变事件
    this.registerForm.valueChanges.subscribe(data => this.onValueChanged(data));
  }
  //找到表单
  @ViewChild('registerForm') registerForm: NgForm;

  onValueChanged(data) {
    for (const field in this.formErrors) {
      this.formErrors[field] = '';
      //取到表单字段
      const control = this.registerForm.form.get(field);
      //表单字段已修改或无效
      if (control && control.dirty && !control.valid) {
        //取出对应字段可能的错误信息
        const messages = this.validationMessages[field];
        //从errors里取出错误类型，再拼上该错误对应的信息
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + '';
        }
      }
    }
  }
  //存储错误信息
  formErrors = {
    'userName': '',
    'passwordGroup.password':'',
    'passwordGroup.repeatPassword':'',
    'checkbox':''
  };
  //错误对应的提示
  validationMessages = {
    'userName': {
      'required': '用户名必填.',
      'minlength': '用户名太短',
    },
    'passwordGroup.password':{
      'required': '请输入密码',
      'minlength': '密码太短',
    },
    'passwordGroup.repeatPassword':{
      'required': '请重复输入密码',
      'minlength': '密码太短',
      'passwordNEQ':'两次输入密码不同',
      'password1InValid':''
    },
    'checkbox':{
      'required':'roles必填'
    }

  };

  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private location:Location,
    private HttpService:HttpService,
    private fileUpload:FileUpload,
    private stroage:StroageService
  ){}

  //初始数据
  private data:any={
    'id':'',
    'username':'',
    'name':'',
    'password':'',
    'roles':[]
  }
  private allData:any = [];
  private id:number = 0;
  private roles:any=[];
  private newRoles:any = [];
  private dataRoles:any=[];
  private isCreate:boolean =false;
  private hasChecked:boolean = true;
  private newAccount:any={
    'username':'',
    'name':'',
    'password':'',
    'roles':[]
  }
  private rePassword:string='';

  ngOnInit():void{
    this.route.params.subscribe((params) => {
      this.id=params['id'];
      if(this.id == 0){
        this.isCreate = true;
        this.hasChecked = false;
      }
    });
    this.getData();
    //this.getRole();
  }

  private goBack(){
    this.location.back();
  }
  //获取数据
  private getData():void{
    if(this.id!=0){
      this.HttpService.getData(API.account+'/'+this.id)
        .then(res=>{
          this.data=res.data;
          this.dataRoles = this.data.roles;
          this.getRole();
        });
    }else {
      this.getRole();
    }
    if(this.data.roles.length>0){
      this.hasChecked = true;
    }
  }

  //获取数据
  private getAllData():void{
    this.HttpService.getData(API.account)
      .then(res=>{
        this.allData=res.data;
      });
  }

  private getRole():void{
    this.HttpService.getData(API.roles)
      .then(res=>{
        this.roles=res.data;
        for(let i=0;i<this.roles.length;i++){
          let fg = false;
          for(let j=0;j<this.dataRoles.length;j++){
            if(this.roles[i].id==this.dataRoles[j].id){
              fg = true;
            }
          }
          this.newRoles.push({'id':this.roles[i].id,'name':this.roles[i].name,'selected':fg})
        }
      });

  }

  private checkID(id){
    if(this.data.roles){
      for(var i=0;i<this.data.roles.length;i++){
        if(this.data.roles[i].id==id){
          return true;
        }
      }
    }
  }
  private changeChecked(id:number){
    for(let i=0;i<this.newRoles.length;i++){
      if(id==this.newRoles[i].id){
        this.newRoles[i].selected=!this.newRoles[i].selected;
      }
    }
  }


  private updateAccount(account:any):void{
    account.roles = [];
    for(let i=0;i<this.newRoles.length;i++){
      if(this.newRoles[i].selected){
        account.roles.push({'id':this.newRoles[i].id,'name':this.newRoles[i].name});
      }
    }
    if(this.data.password == ''){
      delete account.password;
    }
    this.HttpService.postData(API.account,{
      'id':account.id,
      'name':account.name,
      'username':account.username,
      'password':account.password,
      'roles':account.roles
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
      });
  }

  //提交数据
  private createAccount(myForm:any):void{
    for(let i=0;i<this.allData.length;i++){
      if(myForm.username == this.allData[i].username){
        alert('This user already exists!');
        return;
      }
    }
    myForm.roles = [];
    delete myForm.certainPassword;
    for(let i=0;i<this.newRoles.length;i++){
      if(this.newRoles[i].selected){
        myForm.roles.push({'id':this.newRoles[i].id,'name':this.newRoles[i].name});
      }
    }

    this.HttpService.postData(API.account,{
      'name':myForm.name,
      'username':myForm.username,
      'password':myForm.passwordGroup.password,
      'roles':myForm.roles
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/account/EditAccount.component.ts